import board from "../assets/page_assets/sidebar_icon/board.svg";
import card from "../assets/page_assets/sidebar_icon/card.svg";
import live from "../assets/page_assets/sidebar_icon/live.svg";
import casino from "../assets/page_assets/sidebar_icon/casino.svg";
import table from "../assets/page_assets/sidebar_icon/table.svg";
import overview from "../assets/page_assets/sidebar_icon/overview.svg";
import overview_active from "../assets/page_assets/sidebar_icon/overview_active.svg";
import board_active from "../assets/page_assets/sidebar_icon/board_active.svg";
import card_active from "../assets/page_assets/sidebar_icon/card_active.svg";
import live_active from "../assets/page_assets/sidebar_icon/live_active.svg";
import casino_active from "../assets/page_assets/sidebar_icon/casino_active.svg";
import table_active from "../assets/page_assets/sidebar_icon/table_active.svg";
import Logodefault from "../assets/page_assets/Logo.svg";
import Logoanother from "../assets/page_assets/Logorumble.svg";
import search from "../assets/page_assets/search.svg";
import searchhilight from "../assets/page_assets/pageIcon/searchhilight.svg";
import close_search from "../assets/page_assets/pageIcon/close-seacrch.svg";
import { use, useEffect, useRef, useState } from "react";
import { Modal, Button, Tab, Nav, Form } from "react-bootstrap";
import "../assets/css/style.css";
import "../assets/css/login.css";
import Closebtn from "../assets/modal-icons/cross.svg";
import heartImg from "../assets/page_assets/pageIcon/heartImg.svg";
import addAmt from "../assets/page_assets/pageIcon/addAmt.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Success from "../assets/success.gif";
import edit_profile from "../assets/page_assets/edit_profile.svg";
import flag from "../assets/page_assets/pageIcon/flag-india.svg";
import axios from "axios";
import { encryptData } from "../utility/utility";
import closeX from "../assets/page_assets/pageIcon/closeX.svg";
import filledheart from "../assets/page_assets/pageIcon/filledheart.svg";
import MobileSearch from "../component/MobileSearch";
import { useModal } from "../context/ModalContext";
import { Getgamedetails } from "../utility/getGameDetails";
import sidebarmenu from "../assets/page_assets/pageIcon/sidebarmenu.svg";
import arrowlefT from "../assets/page_assets/pageIcon/arrowlefT.svg";
import toast, { Toaster } from "react-hot-toast";
import { setIsRed } from "../redux/slices/uiSlice";
import { useDispatch, useSelector } from "react-redux";


const Sidebar = () => {
  const dispatch = useDispatch();
  const isRed = useSelector((state) => state.ui.isRed);
  const firstOtpInputRef = useRef(null);
  const hostname = window.location.hostname;
  const path = window.location.pathname;
  const liveGamesContainerRef = useRef(null);
  const gameVideosRef = useRef([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [disableBtn, setdiablebtn] = useState(false);
    const [Errormessage, setErrormessage] = useState(false);

  const {
    showModal,
    setShowModal,
    showAddCashModal,
    setShowAddCashModal,
    gameUrl,
    setgameUrl,
    useramount,
    setuseramount, gamesdetails, setgamesdetails, gamescatdetails, setgamescatdetails,
    menuItems, setgamemenu, cashBalance, setCashBalance, setOverviewGames
  } = useModal();
  const { showInsufficientModal, setShowInsufficientModal } = useModal();

  const [otpshowModal, setOtpShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("login");
  const [buttonType, setButtonType] = useState("login");
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const containerRef = useRef(null);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [displayAmount, setDisplayAmount] = useState(0);
  const [message, setMessage] = useState("");
  const [cashError, seCashError] = useState("");
  const [isDemoPlay, setIsDemoPlay] = useState(
    localStorage.getItem("demoplay") === "true"
  );
  const value = localStorage.getItem("demoplay");
  // console.log("111", value);
  useEffect(() => {
    const value = localStorage.getItem("demoplay") === "true";
    setIsDemoPlay(value);
  }, []);

  const pageReloaded = () => {
    setgameUrl("");
    //window.location.href = "/";
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const demoValue = localStorage.getItem("demoplay");
      setIsDemoPlay(demoValue === "true");
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const handleChange = (e) => {
    let value = e.target.value;

    // Remove non-digit characters
    value = value.replace(/[^0-9]/g, "");

    // Remove leading zeros
    value = value.replace(/^0+/, "");

    // If valid (non-zero and up to 6 digits)
    if (value === "" || (value.length <= 6 && parseInt(value) > 0)) {
      setDisplayAmount(value);
      seCashError(""); // Clear any previous error
    }
  };

  const handleBlur = () => {
    if (displayAmount === "" || parseInt(displayAmount) === 0) {
      seCashError("Please enter an amount greater than 0");
    } else {
      seCashError(""); // Valid input, clear error
    }
  };

  // State for input value
  const [searchValue, setSearchValue] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  // Refs to control input and button focus
  const inputRef = useRef(null);
  const buttonRef = useRef(null);

  const [remainingTime, setRemainingTime] = useState(30);
  const [editProfile, setEditProfile] = useState(false);
  const [isSignup, setIsSignup] = useState(false);

  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showProfileEdit, setShowProfileEdit] = useState(false);
  const dropdownRef = useRef(null);
  const userInfoRef = useRef(null);
  const navigate = useNavigate();
  const [playerID, setPlayerID] = useState(localStorage.getItem("playerID"));

  const [mobile, setMobile] = useState("");
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({ username: "", mobile: "" });


  const [gamesList, setGamesList] = useState([]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
        setSearchValue(""); // ✅ clear the input
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };


  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        userInfoRef.current &&
        !userInfoRef.current.contains(event.target)
      ) {
        setShowProfileDropdown(false);
      }
    };

    const handleWindowBlur = () => {
      // Optional: only close if iframe is open
      if (showProfileDropdown) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("blur", handleWindowBlur); // NEW

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("blur", handleWindowBlur); // CLEANUP
    };
  }, [showProfileDropdown]);

  useEffect(() => {
    const handleStorage = () => {
      const updatedID = localStorage.getItem("playerID");
      setPlayerID(updatedID);
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    if (remainingTime > 0) {
      const timer = setTimeout(() => setRemainingTime(remainingTime - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setOtp(["", "", "", ""]);
    }
  }, [remainingTime]);

  const handleResendOTP = () => {
    setOtp(["", "", "", ""]);
    handleGetOtp(); // reset
    // Trigger resend logic here
  };

  const handleBack = () => {
    setOTPerror("");
    setOtp(["", "", "", ""]);
    // Do your back navigation here
    setOtpShowModal(false);
  };
  const location = useLocation();
  const currentURLgame = location.pathname; // e.g., /game/aviator



  // Handle input change
  const handleInputChange = (e) => {
    const input = e.target.value;
    const sanitizedInput = input.replace(/[^a-zA-Z0-9 ]/g, "");
    setSearchValue(sanitizedInput);
    setIsDropdownOpen(true); // open dropdown on typing
  };
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10); // Only digits, max 10
    setMobile(value);
    setErrors((prev) => ({ ...prev, mobile: "" })); // clear error on change
  };
  const currentGame = currentURLgame.startsWith("/game/")
    ? currentURLgame.split("/game/")[1]?.toLowerCase()
    : "";



  // Handle clear button click
  const handleClearClick = () => {
    setSearchValue(""); // Reset input value
    inputRef.current.blur(); // Remove input focus
    buttonRef.current.blur(); // Remove button focus to exit :focus-within
    setIsActive(false);
    setHideTargetDiv(false);
  };







  const [activeItem, setActiveItem] = useState(() => {
    return localStorage.getItem("activeItem") || "home";
  });

  // ✅ whenever activeItem changes → save to localStorage
  useEffect(() => {
    localStorage.setItem("activeItem", activeItem);
  }, [activeItem]);


  // keep highlight in sync
  const [highlightedItem, setHighlightedItem] = useState(activeItem);

  // 🔑 Watch pathname and query params
  useEffect(() => {
    if (location.pathname === "/Favorites") {
      setHighlightedItem("favorites");
      return;
    }

    if (location.pathname === "/") {
      // ✅ Explicitly handle home page
      setActiveItem("home");
      setHighlightedItem("home");
      localStorage.setItem("activeItem", "home");
      return;
    }

    if (location.pathname.startsWith("/games")) {
      const searchParams = new URLSearchParams(location.search);
      const categoryParam = searchParams.get("category");

      if (!categoryParam) {
        setActiveItem("home");
        setHighlightedItem("home");
        localStorage.setItem("activeItem", "home");
      } else {
        const firstWord = categoryParam.split(" ")[0].toLowerCase();
        setActiveItem(firstWord);
        setHighlightedItem(firstWord);
        localStorage.setItem("activeItem", firstWord);
      }
    } else {
      // ✅ restore previous saved item when going back
      const saved = localStorage.getItem("activeItem") || "home";
      setHighlightedItem(saved);
    }
  }, [location]);




  const currentURL = location.pathname;
  const isOverviewAvailable = true; // or false


  const menu_Items = [
    {
      label: "Home",
      inactiveImg: overview,
      activeImg: overview_active,
      url: "/", // instead of "/overview"
    },

    {
      label: "Live Games",
      inactiveImg: live,
      activeImg: live_active,
      url: "/live-games",
    },
    {
      label: "Casino Games",
      inactiveImg: casino,
      activeImg: casino_active,
      url: "/casino-games",
    },
    {
      label: "Card Games",
      inactiveImg: card,
      activeImg: card_active,
      url: "/card-games",
    },
    {
      label: "Table & Board Games",
      inactiveImg: table,
      activeImg: table_active,
      url: "/table-games",
    },
    // {
    //   label: "Board Games",
    //   inactiveImg: board,
    //   activeImg: board_active,
    //   url: "/board-games",
    // },
  ];

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) setIsLoggedIn(true);
  }, []);

  // const handleLogin = () => {
  //   // dummy login logic
  //   localStorage.setItem("token", "dummy-token");
  //   localStorage.setItem("username", username || "Guest");
  //   setIsLoggedIn(true);
  //   setShowModal(false);
  //   setOtpShowModal(false);
  //   setShowSuccess(true);
  // setTimeout(() => {
  //   setShowSuccess(false);
  // }, 2000);
  // };
  const handleGetOtp = async () => {
    setError("");
    if (!mobile) {
      setError("Mobile number is required.");
      return;
    }

    if (mobile.length !== 10 || isNaN(mobile)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    const formData = new FormData();
    formData.append("mobile_number", encryptData(mobile));

    try {
      const response = await axios.post(
        "https://d3vih6zb2nx9ew.cloudfront.net/api/client_user_new.php?type=login",
        formData
      );

      const data = response.data;

      if (data?.Code === 200) {
        localStorage.setItem("mobile", mobile);
        setRemainingTime(Math.ceil(Number(data.Otp_next_allow_at)) || "");
        setOtpShowModal(true);
        setShowModal(false);
      } else {
        setError("Invalid Mobile Number");
      }
    } catch (error) {
      console.error("Login OTP Error:", error);
      setError("Something went wrong. Please try again.");
    }
  };

  const handleLogout = () => {
    setPlayerID("");
    setOtp(["", "", "", ""]);
    setMobile("");

    localStorage.removeItem("mobile");
    localStorage.removeItem("playerID");
    localStorage.removeItem("username");
    localStorage.removeItem("favorites");

    window.dispatchEvent(new Event("storage"));
    setShowConfirmModal(false);
    toast.success("Logged Out Successfully");

      if (location.pathname.toLowerCase() === "/favorites") {
    navigate("/");
  }
  };
  useEffect(() => {
    if (playerID) {
      localStorage.setItem("playerID", playerID);
    } else {
      localStorage.removeItem("playerID");
    }
  }, [playerID]);
  // Mobile menu functionality
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };


  const shouldSkipActive =
    currentURL.includes("OverviewGames") || currentURL.startsWith("/game/") || currentURL.startsWith("/Favorites");


  const isOverviewActive = (url) =>
    (url === "/overview" &&
      (currentURL === "/" || currentURL === "/overview")) ||
    currentURL === url;

  const handleDeposit = async () => {
    setdiablebtn(true);

    var enc_PlayerID = encryptData(playerID);
    const formData = new FormData();
    formData.append("amount", displayAmount);
    formData.append("player_id", enc_PlayerID);

    if (displayAmount > 0) {
      // Open a blank window immediately
      const depositWindow = window.open("", "_blank");

      try {
        const res = await axios.post(
            "https://d3vih6zb2nx9ew.cloudfront.net/api/client_user_new.php?type=deposit",
          formData
        );

        if (res.data.token) {
          const url =
           "https://d3vih6zb2nx9ew.cloudfront.net/payment.php?PlayerID=" +
            playerID +
            "&Token=" +
            res.data.token +
            "&EndTime=" +
            res.data.end_time +
            "&Amount=" +
            displayAmount;

          depositWindow.location.href = url; // set the URL after the API responds
          check_deposit_status(res.data.token);
          // console.log("Deposit Response:", res.data);
            setdiablebtn(false);
        } else {
          depositWindow.close();
         setErrormessage("Deposit Token is Missing, Deposit Failed!.");
          setdiablebtn(false);
        }
      } catch (err) {
        depositWindow.close();
          console.error("API Error:", err);
        setdiablebtn(false);
      }
    } else {
       setErrormessage("Please select or enter an amount to deposit.");

    }
  };


  const check_deposit_status = async (token) => {
    try {
      const formData = new FormData();
      formData.append("token", token);
      formData.append("player_id", encryptData(playerID));

      const res = await axios.post('https://d3vih6zb2nx9ew.cloudfront.net/api/client_user_new.php?type=deposit_update', formData);
      // console.log("Deposit Status Response:", res.data);

      if (res.data.msg == "pending") {
        setTimeout(() => {
          check_deposit_status(token);
        }, 1000); // Retry after 5 seconds
        // console.log("Deposit pending. Please wait for confirmation.");
    setErrormessage("Deposit pending. Please complete the transaction amount.");
        setdiablebtn(true)
      } else if (res.data.msg == 'success') {
        // console.log("success check_deposit_status" + JSON.stringify(res.data));

        if (res.status === 200 || res.status === 202) {
          localStorage.setItem("userCash", res.data.cash);
          setuseramount(res.data.cash);
        }
        try {
          const vaaaaluee = await fetchBalance();
 setShowAddCashModal(false);
        } catch (err) {
         // console.log("err", err);
        }
       setErrormessage("");
        setdiablebtn(false)
      } else {
       //console.log("Deposit Failed!");
        setErrormessage("");
          setShowAddCashModal(false);
        setdiablebtn(false)
      }
   
      setDisplayAmount(0);
      return;
    } catch (err) {
      console.error("API Error:", err);
      alert("Error checking deposit status. Please try again later.");
    }
  };

  const RegisterLogin = async (e) => {
    e.preventDefault();
    let formErrors = { username: "", mobile: "" };
    let isValid = true;

    // Username validation
   if (!username) {
  formErrors.username = "Username is required.";
  isValid = false;
} else if (!/^[A-Za-z]{4,8}$/.test(username)) {
  formErrors.username = "Only letters allowed (4 to 8 characters).";
  isValid = false;
}

    // Mobile validation
    if (!mobile) {
      formErrors.mobile = "Mobile number is required.";
      isValid = false;
    } else if (!/^\d{10}$/.test(mobile)) {
      formErrors.mobile = "Enter a valid 10-digit mobile number.";
      isValid = false;
    }

    setErrors(formErrors);

    if (!isValid) return;
    const encryptedUsername = encryptData(username || "Guest");
    const encryptedMobile = encryptData(mobile);

    const formData = new FormData();
    formData.append("username", encryptedUsername);
    formData.append("mobile_number", encryptedMobile);

    try {
      const response = await axios.post(
        "https://d3vih6zb2nx9ew.cloudfront.net/api/client_user_new.php?type=register",
        formData
      );

      const data = response.data;

      if (data?.Code === 200) {
        localStorage.setItem("username", username || "Guest");
        localStorage.setItem("mobile", mobile);
        setOtpShowModal(true);
        setShowModal(false);
        setRemainingTime(data.Otp_next_allow_at || 120);
        setMessage("Registration Successful");
        setUsername("");
        setTimeout(() => setShowSuccess(false), 1000);
      } else {
        setError("Mobile number already exists");
      }
    } catch (error) {
      console.error("Registration OTP Error:", error);
      setError("Something went wrong. Please try again.");
    }
  };

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [otperror, setOTPerror] = useState("");

  const handleLogin = async () => {
    setOTPerror("");
    const fullOtp = Array.isArray(otp) ? otp.join("") : "";

    if (fullOtp.length !== 4) {
      setOTPerror("Please enter complete 4-digit OTP");
      return;
    }

    const username = localStorage.getItem("username");
    const mobile = localStorage.getItem("mobile") || "Guest";
    const encryptedMobile = encryptData(mobile);
    const encryptedUsername = encryptData(username);

    const formData = new FormData();
    formData.append("username", encryptedUsername);
    formData.append("mobile", encryptedMobile);
    formData.append("otp", fullOtp);

    try {
      const response = await axios.post(
        "https://d3vih6zb2nx9ew.cloudfront.net/api/client_user_new.php?type=otp",
        formData
      );
      const data = response.data;

      if (data?.code === 200) {
        localStorage.setItem("playerID", data.playerID);
        window.dispatchEvent(new Event("storage"));
        setPlayerID(data.playerID);
        setOtp(["", "", "", ""]);
        setMobile(mobile);
        if (isSignup) {
          toast.success("Account Created Successfully");
        } else {
          toast.success('Logged In Successfully')
        }

        setOtpShowModal(false);
        setShowModal(false);
        // setShowSuccess(true);
        // setTimeout(() => setShowSuccess(false), 2000);
      } else {
        alert("OTP verification failed");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      setOTPerror("Something went wrong. Try again.");
    }

    // Getgamedetails();

  };

  useEffect(() => {
    const fetchGames = async () => {
      const data = await Getgamedetails(
        gamesdetails,
        setgamesdetails,
        gamescatdetails,
        setgamescatdetails,
        setgamemenu,
        setOverviewGames
      );

      //console.log("Games loaded in Sidebar:", data);
    };

    fetchGames();
  }, []);

  // ✅ Now safely access filtered games
  const filteredGames = (gamesList.overview || []).filter(
    (game) =>
      game.gamename.toLowerCase().includes(searchValue.toLowerCase()) &&
      game.gamename.toLowerCase() !== currentGame
  );


  const UpdateProfile = async (e) => {
    //console.log("getting in");

    e.preventDefault();

    try {
      // Encrypt values
      const encryptedUsername = encryptData(username);
      const encryptedMobile = encryptData(mobile);
      const encryptedPlayerID = encryptData(playerID);

      // Prepare request body
      const request_data = {
        username: encryptedUsername,
        mobile: encryptedMobile,
        player_id: encryptedPlayerID,
      };

      // API call
      const response = await axios.put(
        "https://d3vih6zb2nx9ew.cloudfront.net/api/client_user_new.php?type=update_profile",
        JSON.stringify(request_data),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;

      // Handle API response
      if (data?.Code === "200") {
        //("getting in2");
        // Example: show a success message
        setShowProfileEdit(false);
        setMessage("Profile updated successfully");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 1000);
        // Optionally refresh balance or profile
      } else {
        //console.log("getting in3");
        console.error("Update failed:", data?.message || data);
        alert(data?.message || "Failed to update profile");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("An error occurred while updating profile.");
    }
  };

  const fetchBalance = async () => {
    if (!playerID) return;
    //console.log("1111");
    try {
      const encryptedPlayerID = encryptData(playerID);
      //console.log("222");

      const formData = new FormData();
      formData.append("player_id", encryptedPlayerID);
      //console.log("3333");

      const response = await axios.post(
        "https://d3vih6zb2nx9ew.cloudfront.net/api/client_user_new.php?type=user_details",
        formData
      );

      setCashBalance(response.data.cash);
      setUsername(response.data.username);
      setMobile(response.data.mobile);

      localStorage.setItem("userCash", response.data.cash);
      setuseramount(response.data.cash);

      if (gameUrl != "") {
       // console.log("not empty gameurl");

        const setdata = {
          balance: response.data.cash,
          requestType: "updateBalance",
        };

        const iframe = document.querySelector(".game-iframe");
        if (iframe) {
          iframe.contentWindow.postMessage(JSON.stringify(setdata), "*");
        }
      } else {
        //console.log("empty gameurl");
      }
      return true;
    } catch (error) {
      //console.error("Error fetching balance:", error);
    }
  };

  useEffect(() => {
    fetchBalance();
  }, [playerID]);


  const [isActive, setIsActive] = useState(false);
  const wrapperRef = useRef(null);
  const [hideTargetDiv, setHideTargetDiv] = useState(false);

  const handleIconClick = (e) => {
    e.stopPropagation();
    setIsActive(true);
    setHideTargetDiv(true); // ✅ hide the target div
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  const latestSearchValue = useRef("");

  useEffect(() => {
    latestSearchValue.current = searchValue;
  }, [searchValue]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        searchValue.trim() === ""
      ) {
        setIsActive(false);
        setHideTargetDiv(false);
      }
    };

    document.addEventListener("click", handleClickOutside); // ✅ bubbling phase
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [searchValue]); // ✅ dependency added

  const handleCloseModal = () => {
    setShowModal(false);
    resetLoginState();
    resetjoinState();
  };

  const resetLoginState = () => {
    setButtonType("login");
    setUsername("");
    setMobile("");
    setActiveTab("login");
    setError("");
    setErrors("");
    setOtp("");
  };

  const resetjoinState = () => {
    setButtonType("join");
    setUsername("");
    setMobile("");
    setActiveTab("join");
    setError("");
    setErrors("");
  }
useEffect(() => {
  if (showAddCashModal) {
    setSelectedAmount(""); 
    setDisplayAmount(0);
  }
}, [showAddCashModal]);

  return (
    <div>
      <Toaster
        position="top-center"
        reverseOrder={true}
      />
      <div className={`header ${isRed ? "blueBackground_header" : ""}`}></div>
      <header className="header">

        <div className="container-fluid">
          <div className="row">
            <div className="col-12 subheader2">
              <div className="search-container position-relative">
                <div className=" subheader1">
                  <button
                    className="mobile-menu-btn"
                    onClick={toggleMobileMenu}
                  >
                    <img src={sidebarmenu} alt="" className="sidebarmenu" />
                  </button>

                  <Link
                    to={"/"}
                    className="mgt-5 mob"
                    onClick={() => {
                      localStorage.setItem("demoplay", "false");
                      pageReloaded(); // call the function
                    }}
                  >
                    <div className={`logo ${hideTargetDiv ? "d-none" : ""}`}>
                      {hostname === "demo.utwebapps.com" ? (
                        <img src={Logodefault} alt="" className="logo" />
                      ) : hostname === "testing-rumblebets.utwebapps.com" ? (
                        <img src={Logoanother} alt="" className="logo" />
                      ) : <img src={Logoanother} alt="" className="logo" />}
                    </div>
                  </Link>
                </div>


                <div
                  className={` ${isDemoPlay ? "d-none" : "search-container position-relative"
                    } `}
                  ref={containerRef}
                >

                </div>

              </div>
              <div className="user-info mobuserLog">
                {playerID ? (
                  // <Link
                  //   to={"/Favorites"}
                  //   className={` ${isDemoPlay ? "d-none" : "user-info mob"}`}
                  //   onClick={() => {localStorage.setItem("demoplay", "false");}}
                  // >
                  //   <div>
                  //     <img src={heartImg} alt="" className="heartImg" />
                  //   </div>
                  // </Link>
                  <Link
                    to={"/Favorites"}
                    className={`${isDemoPlay ? "d-none" : "user-info mob"}`}
                    onClick={() => {
                      localStorage.setItem("demoplay", "false");
                    }}
                  >
                    <div>
                      <img src={heartImg} alt="" className="heartImg" />
                    </div>
                  </Link>

                ) : ("")}

                <div>
                  {!playerID ? (
                    <div className="mobsearch_main">

                      <div
                        className={` ${hideTargetDiv ? "d-none" : "LoginMAin"}`}
                      >
                        <button
                          className="btn btn-success login-btn px-4 py-2"
                          onClick={() => {
                            resetLoginState();
                            setShowModal(true);
                          }}
                        >
                          Login
                        </button>
                      </div>
                    </div>

                  ) : (
                    <div
                      className={`mobsearch_main ${isActive ? "searcHactive" : ""
                        }`}
                    >

                      <div
                        className={`d-flex position-relative ${hideTargetDiv ? "d-none" : ""
                          }`}
                      >
                        <div className="subADD">
                          <div className="balance" id="balance">
                            {cashBalance} INR
                          </div>
                          <button
                            className="add-btn"
                            onClick={() => setShowAddCashModal(true)}
                          >
                            <img src={addAmt} alt="" className="addAmt" />
                          </button>
                        </div>
                        <div
                          className="user-info"
                          onClick={() =>
                            setShowProfileDropdown(!showProfileDropdown)
                          }
                          ref={userInfoRef}
                        >
                          <div className="user-avatar">{username?.charAt(0).toUpperCase() || ""}
</div>
                        </div>
                        {/* <div
                        className="user-info"
                        onClick={() =>
                          setShowProfileDropdown(!showProfileDropdown)
                        }
                      >
                        <div className="user-avatar">JD</div>
                      </div> */}

                        {showProfileDropdown && (
                          <div className="profile-dropdown" ref={dropdownRef}>
                            <div>
                              <div className="dropdown-header text-center">
                                MY PROFILE
                              </div>
                              <div className="dropdown-user d-block text-center">
                                <div className="user-avatar big d-flex justify-content-center">
                                {username?.charAt(0).toUpperCase() || ""}

                                </div>
                                <div className="user-details">
                                  <div className="username">
                                    <span>{username}</span>

                                  </div>
                                  <div className="phone">{mobile}</div>
                                </div>
                              </div>
                            </div>

                            <button
                              className="logout-btn"
                              onClick={() => {
                                setShowConfirmModal(true);
                                setShowProfileDropdown(false);
                              }}
                            >
                              Log Out
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div
        className={`overlay ${isMobileMenuOpen ? "active" : ""}`}
        onClick={toggleMobileMenu}
      />

      <div className="container_re ">
        <div className={`${isRed ? "blueBackground_nav" : ""}`}></div>
        <nav
          className={`sidebar ${isMobileMenuOpen ? "active" : ""}`}
          id="sidebar"
        >

          <div className="close-icon" onClick={toggleMobileMenu}>
            <img src={closeX} alt="Close" />
            {hostname === "demo.utwebapps.com" ? (
              <img src={Logodefault} alt="" className="logo" />
            ) : hostname === "testing-rumblebets.utwebapps.com" ? (
              <img src={Logoanother} alt="" className="logo" />
            ) : <img src={Logoanother} alt="" className="logo" />}

          </div>
          {menuItems.map((item) => {
            const firstWord = item.label.split(" ")[0].toLowerCase();
            const isGamePage = location.pathname.startsWith("/game/");

            return (
              <Link key={item.label} to={item.url} style={{ textDecoration: "none" }}>
                <div
                  className={`navigate--items ${!isGamePage && highlightedItem === firstWord ? "active" : ""}`}
                  onClick={() => {
                    setActiveItem(firstWord);
                    setHighlightedItem(firstWord);
                    if (window.innerWidth <= 768) {
                      toggleMobileMenu();
                    }
                  }}
                >

                  <div className="nav-icon">
                    <img
                      src={item.inactiveImg}
                      className="sideIcon"
                      style={{
                        display:
                          location.pathname === "/Favorites"
                            ? "inline"
                            : !isGamePage && activeItem === firstWord
                              ? "none"
                              : "inline",
                      }}
                      alt={`${item.label} icon`}
                    />

                    <img
                      src={item.activeImg}
                      className="sideIcon active"
                      style={{
                        display:
                          location.pathname === "/Favorites"
                            ? "none"
                            : !isGamePage && activeItem === firstWord
                              ? "inline"
                              : "none",
                      }}
                      alt={`${item.label} active icon`}
                    />
                  </div>
                  <span className="labelName">{item.label}</span>
                </div>
              </Link>
            );
          })}


          {playerID ? (
            <div className="profile-dropdown_mob" ref={dropdownRef}>
              <div className="indideboX">
                <div className="dropdown-user_mob">
                  <div className="user-avatar_mob mx-2">
                   {username?.charAt(0).toUpperCase() || ""}

                  </div>
                  <div className="username_mob mx-1">
                    <span>{username}</span>
                    <div className="user-details">
                      <div className="phone_mob">{mobile}</div>
                    </div>
                  </div>
                  {/* <img
                    className="ms-1 mb-0"
                    src={edit_profile}
                    onClick={() => setShowProfileEdit(true)}
                  /> */}
                </div>

                <Link
                  to={"/Favorites"}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <div className="user-info_se">
                    <div className="user-info_child">
                      <img
                        src={filledheart}
                        alt=""
                        className="filledheart ms-3"
                      />{" "}
                      <span className="mob_fav">Favorites Games</span>
                    </div>
                  </div>
                </Link>
                <div className="user-info_btn">
                  <button
                    className="logout-btn"
                    onClick={() => setShowConfirmModal(true)}
                  >
                    Log Out
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </nav>
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          className="login-modal"
          backdrop="static"
        >
          <Modal.Body className=" text-white p-4 login-modal-body">
            <Tab.Container
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              <div className="d-flex justify-content-between">
                <div></div>
                {buttonType === "login" ? (
                  <p className="text-center mb-3 model-title-text ms-4">
                    LOG IN TO YOUR ACCOUNT
                  </p>
                ) : buttonType === "join" ? (
                  <p className="text-center mb-3 model-title-text ms-4">
                    JOIN US
                  </p>
                ) : (
                  ""
                )}
                <img
                  src={Closebtn}
                  alt=""
                  onClick={() => {
                    setShowModal(false);
                    resetLoginState();
                  }}
                  className="log-close-btn"
                  width="28"
                />
              </div>
              <Nav variant="pills" className="justify-content-center mb-3">
                <div className="overAll">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="login"
                      className="text-white bg-transparent border-0 "
                      onClick={() => {
                        resetLoginState();
                      }}
                    >
                      LOGIN
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="signup"
                      className="text-white bg-transparent border-0 "
                      onClick={() => {
                        resetjoinState();
                      }}
                    >
                      SIGN UP
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="login">
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleGetOtp();
                      setIsSignup(false);
                    }}
                  >
                    <Form.Group className="mb-3 position-relative">
                      <Form.Label>Mobile Number</Form.Label>
                      <div className="mobile-input-wrapper d-flex align-items-center">
                        <img
                          src={flag}
                          alt="India Flag"
                          className="india-flag me-2"
                        />
                        <span className="country-code">+91</span>
                        <input
                          type="text"
                          value={mobile}
                          onChange={handleMobileChange}
                          maxLength={10}
                          className="form-control mobile-input log"
                          placeholder="_____ _____"
                          onFocus={(e) => e.target.select()}
                        />
                      </div>
                      {error && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "small" }}
                        >
                          {error}
                        </div>
                      )}
                    </Form.Group>
                    <Button
                      variant="success"
                      // type="submit"
                      onClick={() => {
                        handleGetOtp();
                        setIsSignup(false);
                      }}
                      className="w-100 otp-button"
                    >
                      <b>Get OTP</b>
                    </Button>
                  </Form>
                </Tab.Pane>
                <Tab.Pane eventKey="signup">
                  <Form onSubmit={RegisterLogin}>
                    <Form.Group className="mb-3 user-names">
                      <Form.Label>User Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Name"
                        value={username}
                        onChange={(e) => {
                          const input = e.target.value;
                          const lettersOnly = input
                            .replace(/[^A-Za-z]/g, "")
                            .slice(0, 8);
                          setUsername(lettersOnly);
                          setErrors((prev) => ({ ...prev, username: "" })); // clear error on change
                        }}
                        maxLength={8}
                        className="signupText"
                      />
                      {errors.username && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "small" }}
                        >
                          {errors.username}
                        </div>
                      )}
                    </Form.Group>

                    {/* <Form.Group className="mb-3">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="+91 XXXXXXXX"
                        value={mobile}
                        maxLength={10}
                        onChange={(e) => {
                          const onlyNums = e.target.value.replace(/\D/g, "");
                          setMobile(onlyNums);
                        }}
                      />
                    </Form.Group> */}
                    <Form.Label>Mobile Number</Form.Label>
                    <div className="mobile-input-wrapper d-flex align-items-center mb-3">
                      <img
                        src={flag}
                        alt="India Flag"
                        className="india-flag me-2"
                      />
                      <span className="country-code">+91</span>
                      <input
                        type="text"
                        value={mobile}
                        onChange={handleMobileChange}
                        maxLength={10}
                        className="form-control mobile-input signupText"
                        placeholder="_____ _____"

                      />
                    </div>
                    {errors.mobile && (
                      <div
                        className="text-danger mb-3"
                        style={{ fontSize: "small" }}
                      >
                        {errors.mobile}
                      </div>
                    )}
                    {error && (
                      <div
                        className="text-danger mt-1 mb-1"
                        style={{ fontSize: "small" }}
                      >
                        {error}
                      </div>
                    )}
                    <Button
                      type="submit"
                      variant="success"
                      className="w-100 otp-button"
                      onClick={() => setIsSignup(true)}
                    >
                      <b>Get OTP</b>
                    </Button>
                  </Form>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Modal.Body>
        </Modal>

        <Modal
          show={otpshowModal}
          centered
          backdrop="static"
          className="login-modal"
          onEntered={() => {
            setTimeout(() => {
              firstOtpInputRef.current?.focus();
            }, 10); // small delay to ensure input is in DOM
          }}
          onHide={() => {
            setOtpShowModal(false);
            setOTPerror("");
          }}
        >
          <Modal.Body className="text-white p-4 login-modal-body">
            <div className="d-flex justify-content-between align-items-start">
              <div></div>

              <p className="text-center mb-4 model-title-text ms-4">
                ENTER OTP
              </p>

              <img
                src={Closebtn}
                alt=""
                onClick={() => {
                  setOtpShowModal(false);
                  setOTPerror("");
                }}
                className="log-close-btn"
                width="28"
              />
            </div>

            <div className="text-center mb-4">
              <h5 className="verify-title">Verify</h5>
              <p className="verify-desc">We’ve sent the code to your phone</p>
            </div>

            {/* <div className="d-flex justify-content-center gap-2 mb-3 otp-input-group">
              {[0, 1, 2, 3].map((_, index) => (
                <input
                  key={index}
                  type="number"
                  maxLength="1"
                  className="otp-input"
                  value={otp[index]}
                  onChange={(e) => {
                    const newOtp = [...otp];
                    newOtp[index] = e.target.value;
                    setOtp(newOtp);

                    // Auto-focus next input
                    if (e.target.value && index < 3) {
                      e.target.nextSibling?.focus();
                    }
                  }}
                />
              ))}
            </div> */}
            <div className="d-flex justify-content-center  mb-3 otp-input-group">
              {/* {[0, 1, 2, 3].map((_, index) => (
                <input
                  key={index}
                  type="tel"
                  inputMode="numeric"
                  maxLength="1"
                  className={`otp-input ${otp[index] ? "valid" : ""} ${otperror ? "invalid" : ""
                    }`}
                  value={otp[index] || ""}
                  onChange={(e) => {
                    setOTPerror("");
                    const val = e.target.value.replace(/[^0-9]/g, ""); // only numbers
                    const newOtp = [...otp];
                    newOtp[index] = val;
                    setOtp(newOtp);

                    if (val && index < 3) {
                      e.target.nextSibling?.focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      if (!otp[index] && index > 0) {
                        e.preventDefault();
                        const prevInput = e.target.previousSibling;
                        prevInput?.focus();
                        const newOtp = [...otp];
                        newOtp[index - 1] = "";
                        setOtp(newOtp);
                      } else {
                        const newOtp = [...otp];
                        newOtp[index] = "";
                        setOtp(newOtp);
                      }
                    } else if (e.key === "ArrowLeft" && index > 0) {
                      e.preventDefault();
                      e.target.previousSibling?.focus();
                    } else if (e.key === "ArrowRight" && index < 3) {
                      e.preventDefault();
                      e.target.nextSibling?.focus();
                    }
                  }}
                />
              ))} */}
              {[0, 1, 2, 3].map((_, index) => (
                <input
                  key={index}
                  type="tel"
                  ref={index === 0 ? firstOtpInputRef : null}
                  inputMode="numeric"
                  maxLength="1"
                  className={`otp-input ${otp[index] !== "" ? "otpfilled" : ""
                    } ${otperror && otp[index] === "" ? "error" : ""}`}

                  value={otp[index]}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!/^\d$/.test(value)) return; // Allow only single digit (0-9)
                    const newOtp = [...otp];
                    newOtp[index] = value;
                    setOtp(newOtp);

                    // Move focus to next input
                    const next = e.target.nextElementSibling;
                    if (next) next.focus();
                    // if (value && index < 3) {
                    //   e.target.nextSibling?.focus();
                    // }
                  }}
                  onKeyDown={(e) => {
                    const { key } = e;

                    if (key === "Backspace") {
                      const newOtp = [...otp];
                      if (otp[index] === "") {
                        if (index > 0) {
                          const prev = e.target.previousElementSibling;
                          if (prev) prev.focus();
                          newOtp[index - 1] = "";
                        }
                      } else {
                        newOtp[index] = "";
                      }
                      setOtp(newOtp);
                    } else if (key === "ArrowLeft") {
                      const prev = e.target.previousElementSibling;
                      if (prev) prev.focus();
                    } else if (key === "ArrowRight") {
                      const next = e.target.nextElementSibling;
                      if (next) next.focus();
                    } else if (!/^\d$/.test(key)) {
                      e.preventDefault(); // block all non-numeric keys
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault(); // Prevent pasting
                  }}

                />
              ))}
            </div>

            {remainingTime > 0 && (
              <div className=" mb-3 otp-timer">
                Code Expires in <span>{remainingTime}</span>
              </div>
            )}
            {remainingTime == 0 && (
              <div className="text-center mb-4">
                <span className="me-1 optTExt">Didn't Receive OTP</span>
                <span className="resend-link" onClick={handleResendOTP}>
                  Resend Code
                </span>
              </div>
            )}



            <p className="otperror">{otperror}</p>
            <Form className="mt-5">
              <Button
                variant="success"
                className="w-100 otp-button mb-3"
                onClick={handleLogin}
              >
                <b>Verify</b>
              </Button>
            </Form>

            <div className="text-center">
              <span className="back-link" onClick={handleBack}>
                <img src={arrowlefT} alt="" className="arrowlefT" /> Back
              </span>
            </div>
          </Modal.Body>
        </Modal>

        {/* Add cash Modal */}

        <Modal
          show={showAddCashModal}
          onHide={() => setShowAddCashModal(false)}
          centered
          className="add-cash-modal"
          backdrop="static"
        >
          <Modal.Body className="text-white p-4 add-cash-modal-body">
            <div className="d-flex justify-content-between align-items-start">
              <div></div>

              <p className="text-center mb-4 model-title-text ms-4 graytitle">ADD CASH</p>

              <img
                src={Closebtn}
                alt=""
                onClick={() => {
                  setShowAddCashModal(false);
                  setDisplayAmount(0);
                }}
                className="log-close-btn"
                width="28"
              />
            </div>

            <div className="text-center cash-balance-box p-3 mb-4">
              <div className=" balance-label mb-1">Available Balance</div>
              <div
                id="balancelabel"
                className="balance-amount text-center mb-3"
              >
                {cashBalance} <span className="INRsym">INR</span>
              </div>
              {/* <input
                  type="number"
                  className="amount-display mb-3 text-center"
                  value={displayAmount}
                  onFocus={()=>setSelectedAmount("")}
                  placeholder="0"
                  onChange={(e) => {
                    const value = parseInt(e.target.value) || 0;
                    setDisplayAmount(value);
                    
                  }}
                /> */}
              <div className="">
                <input
                  type="text"
                  className="amount-display mb-3 text-center currency-input"
                  value={displayAmount === "" ? "" : `₹${displayAmount}`}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onChange={(e) => {
                    let value = e.target.value.replace(/₹/g, "").trim(); // remove ₹ if pasted
                    if (!/^\d*$/.test(value)) return;
                    if (value.length > 1 && value.startsWith("0")) {
                      value = value.replace(/^0+/, "");
                    }
                    const numericValue = value === "" ? "" : parseInt(value, 10);
                    if (numericValue > 100000) return;
                    setDisplayAmount(value === "" ? "" : numericValue);
                     setErrormessage("");
                          setdiablebtn(false);
                  }}
                  onFocus={() => {
                    if (displayAmount === 0) setDisplayAmount("");
                    setSelectedAmount("");
                  }}
                  onBlur={() => {
                    if (displayAmount === "") setDisplayAmount(0);
                  }}
                />

              </div>

              <div className="d-flex justify-content-center gap-1 flex-wrap">
                {["+100", "+500", "+1000", "+5000"].map((amt) => {
                  const value = parseInt(amt.replace("+", ""));
                  return (
                    <button
                      key={amt}
                      className={`cash-option-btn ${selectedAmount === amt ? "active" : ""
                        }`}
                      onClick={() => {
                        setSelectedAmount(amt);
                        setDisplayAmount((prev) => {
                          const newAmount = prev + value;
                          return newAmount <= 100000 ? newAmount : prev;
                        });
                          setErrormessage("");
                          setdiablebtn(false);
                      }}
                    >
                      {amt}
                    </button>
                  );
                })}
              </div>
            </div>
<div className="Errormessage">{Errormessage}</div>

            <Button
              className="w-100 deposit-button"
              onClick={() => handleDeposit()}
                disabled={disableBtn}
            >
              Deposit Cash
            </Button>
          </Modal.Body>
        </Modal>
        {/* logout confirm modal */}
        <Modal
          show={showConfirmModal}
          onHide={() => setShowConfirmModal(false)}
          centered
          contentClassName="logout-modal-content addBG"
          backdropClassName="logout-modal-backdrop"
          className="logout-confirm-modal"
          backdrop="static"
        >
          <Modal.Body className="text-center">
            <div className="alerttext">ALERT</div>
            <p className="modal-text">
              Are you sure you want to <br /> logout?
            </p>
            <div className="d-flex justify-content-center gap-2 mt-4">
              <Button
                variant="outline-light"
                className="cancel-btn"
                onClick={() => setShowConfirmModal(false)}
              >
                No Cancel
              </Button>
              <Button
                variant="danger"
                className="logout-confirm-btn"
                onClick={handleLogout}
              >
                Yes, Logout
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        {/* Edit Profile  */}

        <Modal
          show={showProfileEdit}
          onHide={() => setShowProfileEdit(false)}
          centered
          className="edit-profile-modal"
        // backdrop="static"
        >
          <Modal.Body>
            <div className="position-relative">
              <h5 className="modal-title">EDIT PROFILE</h5>
              <img
                src={Closebtn}
                alt="Close"
                className="close-icon"
                width="28"
                onClick={() => setShowProfileEdit(false)}
              />
            </div>
            <Form onSubmit={UpdateProfile}>
              <Form.Group className="mb-3">
                <Form.Label>User Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Mobile Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter 10-digit mobile number"
                  value={mobile}
                  maxLength={10}
                  inputMode="numeric"
                  pattern="\d{10}"
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow only digits
                    if (/^\d*$/.test(value)) {
                      setMobile(value.slice(0, 10)); // Limit to 10 digits
                    }
                  }}
                  onBlur={() => {
                    if (mobile.length !== 10) {
                      alert("Mobile number must be exactly 10 digits.");
                    }
                  }}
                />

              </Form.Group>
              <div className="d-flex justify-content-center gap-2 mt-4">
                <Button
                  variant="outline-danger"
                  className="cancel-btn-edit w-100"
                  onClick={() => setShowProfileEdit(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="success"
                  className="w-100 otp-button"
                >
                  Update
                </Button>
              </div>
              {/* <Button
                type="submit"
                variant="success"
                className="w-100 otp-button"
              >
               Update
              </Button> */}
            </Form>
          </Modal.Body>
        </Modal>
        {/* Succeess */}
        <Modal
          show={showSuccess}
          onHide={() => setShowSuccess(false)}
          centered
          backdrop="static"
          keyboard={false}
          className="success-model text-white text-center"
        >
          <Modal.Body>
            <div className="d-flex flex-column align-items-center justify-content-center my-5">
              <img
                src={Success}
                alt="Success"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "contain",
                }}
              />
              <h5 className="mt-3 success-message">{message}</h5>
            </div>
          </Modal.Body>
        </Modal>




        {showInsufficientModal && (
          <Modal
            show={showInsufficientModal}
            onHide={() => setShowInsufficientModal(false)}
            centered
            className="add-cash-modal custoM"
            backdrop="static"

          >
            <Modal.Body className="text-white add-cash-modal-body paddding-toP">


              <div className="d-flex justify-content-between align-items-start">
                <div></div>

                <p className="text-center mb-4 model-title-text ms-4 graytitle">INSUFFICIENT BALANCE</p>

                <img
                  src={Closebtn}
                  alt=""
                  onClick={() => setShowInsufficientModal(false)}
                  className="log-close-btn2"
                  width="28"
                />
              </div>
              <div className="">


                <div className="text-center model-title-text  WhitEtitle">Your wallet balance is low.</div>
                <div className="text-center mb-4 model-title-text  WhitEtitle">
                  Add funds to play with real cash.</div>

              </div>
              <Button
                className="w-100 deposit-button"
                onClick={() => {
                  setShowInsufficientModal(false);
                  setShowAddCashModal(true);
                }}

              >
                Add Cash
              </Button>
            </Modal.Body>
          </Modal>


        )}




      </div>
    </div>
  );
};

export default Sidebar;